export const PEER_NAVIGATION = [
  { heading: 'Peers', path: '/peers' },
  { heading: 'Schedule Overview', path: '/peers/schedule-overview' },
  { heading: 'Schedule History', path: '/peers/schedule-history' },
  { heading: 'Peersona Chat Logs', path: '/peers/peersona-chat-logs' },
];
